import React from "react";

// components
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";

// styled components
import { Wrapper } from "../../theme/GlobalStyle";

// react icons
import { CgClose } from "react-icons/cg";
import Typography from "../Typography/Typography";

const ConfirmDialog = ({
  successTitle,
  feildTitle,
  handleClose,
  show,
  title,
  onSuccess,
  onFeild,
  name,
}) => {
  return (
    <BootstrapModal
      modaltitle={title}
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      {name && <Typography>{`آیا از حذف ${name} مطمئن هستید؟`}</Typography>}
      <Wrapper>
        <Button
          onclick={onSuccess}
          color="#fff"
          bgColor="#28A745"
          small="100px"
          size="14px"
          spaceLeft=".5rem"
        >
          {successTitle}
        </Button>
        <Button
          onclick={onFeild}
          bgColor="#0D6EFD"
          color="#fff"
          small
          size="14px"
        >
          {feildTitle}
        </Button>
      </Wrapper>
    </BootstrapModal>
  );
};

export default ConfirmDialog;
